import { createAction, props } from '@ngrx/store';
import { Iso3166_2Country } from './model';

export const loadIso3166_2CountryCodes = createAction('[Country Codes Iso3166_2] Load');

export const loadIso3166_2CountryCodesSuccess = createAction(
    '[Country Codes Iso3166_2] Load Success',
    props<{ data: Iso3166_2Country[] }>(),
);

export const loadIso3166_2CountryCodesFailure = createAction(
    '[Country Codes Iso3166_2] Load Failure',
    props<{ error: any }>(),
);
